import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { asyncWithLDProvider, useFlags } from 'launchdarkly-react-client-sdk';
import { setLaunchFlagsForNav } from '../reducers/auth';
import { v4 } from 'uuid';
import associateRouter from './permissionRouters/associateRouter';
import managerRouter from './permissionRouters/managerRouter';
import adminRouter from './permissionRouters/adminRouter';
import NoRouter from './permissionRouters/noRouter';
import { addLoadingList, removeLoadingList } from '../reducers/notification';
import NotFound from '../components/Routes/NotFound';
import applyPlanGating from '../utils/applyPlanGating';

// Syncs LaunchDarkly flags to Redux for all routes, gating feature-flagged entries
// against the merchant's plan features so both checks must pass.
const FlagSyncBase = ({ merchantFlags, children }) => {
  const flags = useFlags();

  useEffect(() => {
    if (Object.keys(flags).length > 0) {
      setLaunchFlagsForNav(applyPlanGating(flags, merchantFlags));
    }
  }, [JSON.stringify(flags), merchantFlags]);

  return children;
};

const FlagSync = connect(state => ({ merchantFlags: state.auth.merchantFlags }))(FlagSyncBase);

const routerHandler = props => {
  const [elRouter, setRouter] = useState(associateRouter);
  const [loading, setLoading] = useState(true);
  const componentMounted = useRef(true);

  const launchDarklyProvider = async router => {
    const uuid = v4();
    addLoadingList(uuid);
    const LDProvider = await asyncWithLDProvider({
      clientSideID: process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_ID,
      context: {
        kind: 'merchant',
        key: props?.auth?.licenseKey,
      },
      // options: { /* ... */ }
    });
    removeLoadingList(uuid);
    setLoading(false);
    setRouter(
      <LDProvider>
        <FlagSync>{router()}</FlagSync>
      </LDProvider>
    );
  };

  useEffect(() => {
    if (props.auth.userId) {
      switch (props.auth.role) {
        case 'ADMIN':
          launchDarklyProvider(adminRouter);
          break;
        case 'MANAGER':
          launchDarklyProvider(managerRouter);
          break;
        case 'ASSOCIATE':
          launchDarklyProvider(associateRouter);
          break;
        default:
          launchDarklyProvider(NoRouter);
          break;
      }
      return;
    }
    return () => {
      componentMounted.current = false;
    };
  }, [props.auth.userId]);

  return (
    <>
      {elRouter}
      {!loading && <Route path="/*" component={NotFound} displayName="NotFound" />}
    </>
  );
};

const mapStateToProps = state => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(routerHandler);
